export default "__VITE_PUBLIC_ASSET__9df8383e__"